import React from 'react';
import { ListItemText, List, ListItem, Divider } from '@material-ui/core';
import { makeStyles } from '@material-ui/core'
import { useTranslation } from 'react-i18next';


const useStyles = makeStyles((theme) => ({
    img: {
        maxWidth: "4em",
        maxHeight: "4em",
    }
}));

interface Props {
    onSearch?: (keyword: string)=>void
    updateAt: moment.Moment
}

function Sidebar(props: Props) {

    const classes = useStyles()
    const [t] = useTranslation()

    const linkTo = (url: string) => {
        console.log(url)
        if (url) {
            props?.onSearch?.(url)
        }
    }

    return (
        <div>
            <List>
                <ListItem>
                    <ListItemText secondary={t("message.header.subTitle")}>
                        <img src="/logo.png" className={classes.img} alt="logo" /><br/>{t("message.header.brand")}
                    </ListItemText>
                </ListItem>
            </List>
            <Divider />
            <List>
                <ListItem button onClick={()=>linkTo("/")}>
                    <ListItemText>
                        {t("message.sidenav.home")}
                    </ListItemText>
                </ListItem>
                <ListItem button onClick={()=>linkTo("/document/about")}>
                    <ListItemText>
                        {t("message.sidenav.about")}
                    </ListItemText>
                </ListItem>
                <ListItem button onClick={()=>linkTo("/document/how-to-use")}>
                    <ListItemText>
                        {t("message.sidenav.howtouse")}
                    </ListItemText>
                </ListItem>
                <ListItem button onClick={()=>linkTo("/document/license")}>
                    <ListItemText>
                        {t("message.sidenav.license")}
                    </ListItemText>
                </ListItem>
            </List>
        </div>
    )
}

export default Sidebar;